<template>
    <div class="insurance">
       <div class="header">
        <div class="title">
            <div>{{cstUserData.insName}}</div>
            <div>{{cstUserData.policyNo|maskStr}}</div>
        </div>
        <div class="headerContent">
            <div class="img">
                <img :src="require('@/static/img/wode_bapxian.png')" alt="">
            </div>
            <div class="headerInf">
                <div>
                    <div>姓名:{{cstUserData.fullName}}</div>
                    <div>状态:有效</div>
                </div>
                <div>{{cstUserData.effectDate}} 至 {{cstUserData.expireDate}}</div>
            </div>
        </div>
        <div class="money"> 
            <div>
                <div></div>
                <div></div>
            </div>
            <div>
                <div>余额：<span class="amt">￥{{cstUserData.fundBalance/100}} </span>元</div>
                <div></div>
            </div>
        </div>
       </div>
       <!--
       <div class="jd">
            <img :src="require('@/static/img/jd.jpg')" alt="">
       </div>
       -->
       <div style="margin-top:10px;"></div>

       <van-cell-group>
           <van-cell title="直付密码" icon="lock"  is-link @click="mgrPayCode"/>
          <!-- <van-cell title="修改手机号" icon="phone-o"  is-link to="/pay/payCode?hasPwd=y"/> -->
           <van-cell title="支付明细" icon="gold-coin-o" is-link to="/pay/payList"/>
           <van-cell title="理赔记录" icon="todo-list-o" is-link @click="toClaim"/>
           <van-cell title="登录密码" icon="lock"  is-link to="/my/updateLoginPwdPage"/>
       </van-cell-group>     

       <van-cell-group>
        <!--<van-cell title="药店直付" icon="shield-o"  is-link @click="toDPay"/>
        <van-cell title="拍照理赔" icon="photo-o" is-link @click="toClaim"/>
        <van-cell title="在线问诊" icon="todo-list-o" is-link to="/zxwz/zxwzPage"/>-->
            <van-cell title="关于" icon="more-o" value="版本V1.0.1"  />
            <van-cell title="用户协议" icon="envelop-o" is-link to="/other/user_agee"/>
       </van-cell-group>

       <div style="margin-top:10px;"></div>
       
        
        <div style="text-align: center;    padding-bottom: 10px;">
            <van-button  size="small" type="warning" @click="preUnbindUser()">取消绑定</van-button>
        </div>
        

        
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import InsuranceCard from '@/components/InsuranceCard.vue';
export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      return {
          userName:'11',
          userPlnCode:'',

          lysCstUserId:null,

          cstUserData:{
                  lysCstUserId:"",
                  cropName:"",//    企业名称
                  insName:"",//     保司名称
                  fullName:"",//    姓名
                  effectDate:"",//   开始日期
                  expireDate:"",//   结束日期
                  fundBalance:"", //基金余额
                  hasPwdFlag:"",  //是否设置了网上支付密码 y/n 已设置/未设置
                  policyNo:'',
          },
          thirdCode: null,
          thirdType: null,
          hasThirdFlag : false,
      };
    },
    methods: {
        toClaim()
		{
			//this.toPukangByH5("KSLP-LPJL");
			//window.location.href = "https://pk-pl-h5-test.pukangbao.com/storeCollectionTP?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";

            window.location.href="http://vueh5test.ebao51.cn/H5/jkxclaim/claim_fund.html";
		},
		toDPay(){
			//this.toPukangByH5("SMZF");
			window.location.href = "https://pk-pl-h5-test.pukangbao.com/scanning-code-page?cardCode=2023081500000079&signMD5=cc6409a1a22c1983f8d40e9b46ab004f&terminal=18&platformCode=lys&terminalType=3&thirdUserCode=511112195312191411";
		}, 
        //取消绑定
        preUnbindUser(){
             if(!this.lysCstUserId){
                
                return;
            }
            // 基本确认框
            this.$dialog.confirm({
            title: '提示',
            message: '确定要取消绑定吗？',
            })
            .then(() => {
                // 用户点击确认
                console.log('确认');
                this.unbindUser();
            })
            .catch(() => {
                // 用户点击取消
                console.log('取消');
            });
        },
        unbindUser(){

			let data = {
				lysCstUserId:this.lysCstUserId,
                thirdCode:this.thirdCode,
                thirdType:this.thirdType
			}
        			
			this.$getRequestData20('unBind', data)
			.then(result =>{

				console.log(result);

				if(result.resultCode !== '0000'){
 					
					
					this.$toast.fail(result.msg);

					
				}else{
                    this.$toast.success("取消绑定成功");
                    
                    sessionStorage.removeItem('thirdType');
                    sessionStorage.removeItem('thirdCode');

                    sessionStorage.clear();

					this.toLoginPage();

				}
			})
			.catch(err => {
				console.log(err);
				this.$toast.fail(err);
				
			})            
        },
        queryCstData(){
            
            if(!this.lysCstUserId){
                
                this.toLoginPage();

                return;
            }

			let data = {
				lysCstUserId:this.lysCstUserId
			}
        			
			this.$getRequestData20('queryCstUserData', data)
			.then(result =>{

				console.log(result);

				if(result.resultCode !== '0000'){
 					
					
					this.$toast.fail(result.msg);

					this.toLoginPage();
				}else{

					this.cstUserData = result.bizData;

				}
			})
			.catch(err => {
				console.log(err);
				this.$toast.fail(err);
				
			})
		},
        //支付密码
        mgrPayCode(){
            let hasPayPwd = sessionStorage.getItem('hasPayPwd');

            if(hasPayPwd && hasPayPwd=='y'){
            //修改
             this.$router.push({ path: '/pay/payCode?hasPwd=y' });
            }else{
            //首次设置  
            this.$router.push({ path: '/pay/payCode?hasPwd=n' });
            }

        },

		toLoginPage(){
			
			 this.$router.push({ path: '/login/loginPage' });
		}
    },
    computed: {},
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.lysCstUserId = sessionStorage.getItem('lysCstUserId');

        this.thirdCode = sessionStorage.getItem('thirdCode');
        this.thirdType = sessionStorage.getItem('thirdType');

        if(this.thirdCode){
            this.hasThirdFlag = true;
        }else
        {
            this.hasThirdFlag = false;
        }
        
        this.queryCstData();
    },
};
</script>

<style lang="less" scoped>

::v-deep .van-cell {
  font-size: 16px !important;
}

//@import url(); 引入公共css类
.insurance {
    background-color: #f2f2f4;

}
.header {
    background-color:cornflowerblue;
    color: #fff;
    padding: 18px 15px;
    margin: 5px;
    border-radius: 7px;
    .title {
        display: flex;
        justify-content: space-between; /* 左右对齐 */
        font-size: 18px;

        >div{
            .left,
            .right {
            white-space: nowrap;
            }
        }
    }
    .headerContent {
        display: flex;
        justify-content: space-between;
        margin: 10px 0;
        .img{
            width: 70px;
            padding-left: 15px;
            padding-top: 10px;
            img {
                border-radius: 50%;
                width: 100%;
            }
        }    
        .headerInf{
            display: flex;
            justify-content: space-around;
            flex-direction: column;
            flex-wrap: nowrap;
            align-items: flex-end;  /* 所有子项右对齐 */
            width: 220px;
            >div:first-child {
                display: flex;
                justify-content: space-between;
                width: 85%;
            }
        }
        
    }
    .money {
            display: flex;
            justify-content: space-between;
            margin: 0px 0px;
            font-size: 13px;
            height: 26px;
            >div {
                display: flex;
                justify-content: space-between;
                flex-direction: column;
            }
        }
}
.jd {
    margin: 20px 0;
    img {
        width: 100%;    
    }
}
.van-cell--clickable {
    margin-top: 4px;
}
.insurance{
    text-align: left;
}
    .van-cell-group {
        margin-top: 8px;
    }
  
.amt{
    font-size: 18px;
}
</style>
